import { I18n } from '@calendly/i18n';
import { IconButton } from '@calendly/ui/components/icon-button';
import { AddCircleIcon, AddMiniIcon } from '@calendly/ui/components/icons';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useBooleanState } from 'hooks/useBooleanState';
import { CopyButton } from '../copy_button';
import { addInterval } from '../utils';
import WdayRule from '../wday_rule';
import { ActionContainer, Checkbox, DayContainer, DayIcon } from './styles';
const labelCss = "lyqvbns";
const Label = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(labelCss, props.className)} />;
});
export const Day = ({
  wday,
  days,
  handleCheckboxClick,
  setWdayIntervals,
  cloneWeekdayAvailability,
  className,
  alwaysAbbreviate = false,
  allowCopy = true,
  allowCopyUnavailable = true,
  redesignStyling
}) => {
  const intervals = days[wday];
  const isPhone = useDeviceType('isPhone');
  const dayNames = I18n.t('date.day_names_hash');
  const abbrDayNames = I18n.t('date.abbr_day_names_hash');
  const [autoFocusLastInterval, startAutoFocusLastInterval, stopAutoFocusLastInterval] = useBooleanState(false);
  const handleAdd = () => {
    setWdayIntervals(wday, addInterval(intervals));
    startAutoFocusLastInterval();
  };
  return <DayContainer key={wday} data-component={wday} onBlur={stopAutoFocusLastInterval} className={className}>
      {redesignStyling ? <DayIcon>
          {abbrDayNames[wday].slice(0, 1)}
        </DayIcon> : <Checkbox checked={intervals.length > 0} onChange={checked => handleCheckboxClick(checked, wday)} label={<Label>{isPhone && !alwaysAbbreviate ? dayNames[wday] : abbrDayNames[wday]}</Label>} />}
      <WdayRule day={wday} intervals={intervals} onChange={data => setWdayIntervals(wday, data)} autoFocusLast={autoFocusLastInterval} />
      <ActionContainer>
        {redesignStyling ? <IconButton title={I18n.t('publisher.availability.schedules.new_interval_with_day', {
        day: dayNames[wday]
      })} onClick={handleAdd} size="small">
            <AddCircleIcon />
          </IconButton> : <IconButton title={I18n.t('publisher.availability.schedules.new_interval_with_day', {
        day: dayNames[wday]
      })} onClick={handleAdd}>
            <AddMiniIcon />
          </IconButton>}
        {allowCopy && (allowCopyUnavailable || intervals.length > 0) && <CopyButton onApply={cloneWeekdayAvailability} day={wday} weekdayRules={days} redesignStyling={redesignStyling} />}
      </ActionContainer>
    </DayContainer>;
};

require("./day.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./day.js");